import {
  ADD_BRANCH,
  GET_BRANCH,
  EDIT_BRANCH,
  DELETE_BRANCH,
  BLOCK_BRANCH,
} from "../constants/action-types";

// Reducer to add article
const initilState = {
  state: "",
};

const branchReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_BRANCH:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_BRANCH:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_BRANCH:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case DELETE_BRANCH:
      const deleteIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: deleteIndex,
      };
    case BLOCK_BRANCH:
      const blockIndex = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(blockIndex, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    default:
      return state;
  }
};

export default branchReducer;
